import { AcquiringOwnerId, RefillType } from '../settings'

export type BankCardId = string

export enum CardSystem {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Mir = 'mir',
  Unionpay = 'unionpay',
  Jcb = 'jcb',
  Other = 'other',
}

export const isCardSystem = (value: string): value is CardSystem => {
  return Object.values(CardSystem).includes(value as CardSystem)
}

export enum CardIssuer {
  AKBank = 'akbank',
  AgroPromCredit = 'agropromcredit',
  AlfaBank = 'alfabank',
  BSPB = 'bspb',
  DOMRFBank = 'domrfbank',
  GazPromBank = 'gazprombank',
  HomeCreditBank = 'homecreditbank',
  MKB = 'mkb',
  MTSBank = 'mtsbank',
  MetallInvestBank = 'metallinvestbank',
  NovikomBank = 'novikombank',
  OTPBank = 'otpbank',
  OZONCard = 'ozoncard',
  OtkritieBank = 'otkritiebank',
  PochtaBank = 'pochtabank',
  RGSBank = 'rgsbank',
  RNCB = 'rnkb',
  RSHB = 'rshb',
  RaiffeisenBank = 'raiffeisenbank',
  RosBank = 'rosbank',
  Sber = 'sber',
  SberBank = 'sberbank',
  SovComBank = 'sovcombank',
  TBank = 'tbank',
  TinkoffBank = 'tinkoffbank',
  UniCreditBank = 'unicreditbank',
  UralSib = 'uralsib',
  VTB = 'vtb',
  Unknown = 'other',
}

export const isCardIssuer = (value: string): value is CardIssuer => {
  return Object.values(CardIssuer).includes(value as CardIssuer)
}

export type RecurrentBankCardParams = {
  refillType: RefillType
  id: AcquiringOwnerId
  ownerType: 'Parent' | 'Student'
}

export type RecurrentBankCard = {
  id: BankCardId
  lastFourDigits: string
  countryCode: 'ru' | string
  issuer: CardIssuer
  system: CardSystem
}
